<sisense-sdk-element (valueChange)='renewToken($event)' *ngIf="showElement"></sisense-sdk-element>

